import React from "react";
import Navbar from "../components/Navbar";
import FooterLinks from "../components/FooterLinks";
import AboutUs from "../components/AboutUs";
import Contact from "../components/Contact";
import Chat from "../components/Chat";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const About = () => {
  const options = {
      items: 1,
      loop: true,
      margin: 10,
      nav: false,
      autoplay: true,
      autoplayTimeout: 3000,
      responsive: {
        0: { items: 1 },
        600: { items: 1 },
        1000: { items: 1 }
      }
  }

  return (
    <>
    {/* Navbar Component*/}
    <Navbar activePage = "About" />
    <section id="mainHome" className="mainHomeAbout">
      <div className="container">
        <div className="row mainRow mainRowAbout">
          <div className="col-lg-6 centerCols">
            <div className="w-100">
            <h1 className="mainTitle">Introducing you <br/>Who am I</h1>
            <p className="mainPara">
            I’m a passionate full-stack web developer and designer! As someone who’s always enjoyed exploring her creative and logical side, web developing and designing allows me to get the best of both worlds.<br/><br/>It’s simple, I use my creative side to design and my keen eye for detail and logic to code! As a bonus, being great at both aspects allows me to ensure that no detail is lost in translation.
            </p>
            </div>
          </div>
          <div className="col-lg-6 centerCols centerColsAbout aboutSliderCon">
            {/* <img className="mainGifAbout" src="images/about2.png"></img> */}
            <OwlCarousel  className="owl-carousel owl-theme w-100" {...options}>
              <div className="item"><img src="images/slider1.png" alt="Slide 1"></img></div>
              <div className="item"><img src="images/slider2.png" alt="Slide 2"></img></div>
              <div className="item"><img src="images/slider3.png" alt="Slide 3"></img></div>
            </OwlCarousel>
          </div>
        </div>
      </div>
      <div id="circle1"></div>
      <div id="circle2"></div>
    </section>


    {/* AboutUs Component*/}
    <AboutUs />

    {/* Contact Component*/}
    <Contact />

    {/* FooterLinks Component*/}
    <FooterLinks />
    
    {/* Chat Component*/}
    <Chat />
    </>
  );
};

export default About;
